document.querySelectorAll('[data-ha-size-guide]').forEach((section) => {
  const triggers = Array.from(section.querySelectorAll('[data-tab-trigger]'));
  const panels = Array.from(section.querySelectorAll('[data-tab-panel]'));
  const unitButtons = Array.from(section.querySelectorAll('[data-unit-trigger]'));
  const unitTables = Array.from(section.querySelectorAll('[data-unit-table]'));

  const activateTab = (tabId) => {
    triggers.forEach((trigger) => {
      const isActive = trigger.dataset.tabTrigger === tabId;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      trigger.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== tabId;
    });
  };

  const setUnit = (unit) => {
    section.dataset.unit = unit;

    unitButtons.forEach((button) => {
      const isActive = button.dataset.unitTrigger === unit;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    unitTables.forEach((table) => {
      table.hidden = table.dataset.unitTable !== unit;
    });
  };

  if (triggers.length > 0) {
    const initialTab = triggers.find((trigger) => trigger.classList.contains('is-active')) || triggers[0];
    activateTab(initialTab.dataset.tabTrigger);

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => activateTab(trigger.dataset.tabTrigger));
    });
  }

  if (unitButtons.length > 0) {
    const defaultUnit = section.dataset.defaultUnit || 'imperial';
    setUnit(defaultUnit);

    unitButtons.forEach((button) => {
      button.addEventListener('click', () => setUnit(button.dataset.unitTrigger));
    });
  }
});
